import {reportJobViewEvent, reportJobApplyEvent} from "../utils/analytics";
import {showModal as showPasswordIsNotSetModal} from "../pages/account/password-is-not-set-modal";
import $jsAPI from "../front_end_api";
import {addSkipRegWallParamToHrefAttrIfNeeded} from "../utils/regwallUtil";
import {makeLinksOpenInNewTab} from "../utils/rich-editor-helper";

const job = window.job ? window.job : null;
const applyBtn = $('#job-apply-btn');

let applyByEmailModal             = null;
let regWallModal                  = null;
let userStatusIsNotConfirmedModal = null;
let userPasswordIsMissingModal    = null;

let shouldRegWallModalBeDisplayed                  = false;
let shouldUserStatusIsNotConfirmedModalBeDisplayed = false;
let shouldUserPasswordIsMissingModalBeDisplayed    = false;

function initJobInner() {
  if (!job) {
    return;
  }

  applyByEmailModal             = $('#modal-apply-info');
  regWallModal                  = $('#modal-apply-regwall');
  userStatusIsNotConfirmedModal = $('#modal-account-is-not-confirmed');
  userPasswordIsMissingModal    = $('#modal-password-is-not-set');

  shouldUserStatusIsNotConfirmedModalBeDisplayed = userStatusIsNotConfirmedModal.length;
  shouldUserPasswordIsMissingModalBeDisplayed    = userPasswordIsMissingModal.length;

  const jobBoardAdminWantsRegWallToBeShown = $jsAPI.callFunction('shouldRegistrationWallBeDisplayed', [job], true);

  //This is the final boolean variable that determines whether the registration wall modal should be displayed or not.
  shouldRegWallModalBeDisplayed = jobBoardAdminWantsRegWallToBeShown && regWallModal.length;

  if (!shouldRegWallModalBeDisplayed) {
    addSkipRegWallParamToHrefAttrIfNeeded(applyBtn, job);
  }

  if(window.jobDetailsPage) {
    $jsAPI.fireEvent('job:view', job)
    reportJobViewEvent(job);
    makeLinksOpenInNewTab('#quill-container-with-job-details');
  }

  if (window.showModalOnLoad) {
    showModalIfNeeded();
  }

  applyBtn.click(function () {
    $jsAPI.fireEvent('job:apply_button_clicked', job, 'job_details')
    reportJobApplyEvent(job);
    return showModalIfNeeded()
  });
}

function showModalIfNeeded() {
  let applyBtnClickShouldBeBlockedByModal = shouldUserStatusIsNotConfirmedModalBeDisplayed || shouldUserPasswordIsMissingModalBeDisplayed || shouldRegWallModalBeDisplayed;

  if(applyBtnClickShouldBeBlockedByModal) {
    _showBlockerModal();
    return false;

  } else {

    if(job.apply_by === 'by_email') {
      applyByEmailModal.modal('show');

      if (!window.showModalOnLoad) {
        axios.get(applyBtn.attr('href'));
      }
      return false;
    }
  }
}

function _showBlockerModal() {
  if (shouldUserPasswordIsMissingModalBeDisplayed) {
    showPasswordIsNotSetModal();
  } else if(shouldUserStatusIsNotConfirmedModalBeDisplayed) {
    userStatusIsNotConfirmedModal.modal('show')
  } else if (shouldRegWallModalBeDisplayed) {
    const formStepContainer = $('.form-step-container')
    $(formStepContainer).removeClass('active-step');
    $(formStepContainer).first().addClass('active-step');
    regWallModal.modal('show');

    if ($('#job-apply-form-container').data('active-step') === 'resume') {
      $('.submit-apply-regwall-wrapper').addClass('d-none');
    }

    setTimeout(() => {
      const regWallOpenedEvent = new CustomEvent('reg_wall_opened');
      document.dispatchEvent(regWallOpenedEvent);
    }, 400)

    $jsAPI.fireEvent('job_seeker:reg_wall_opened', job)
  }

}

$(initJobInner);
